export const FETCH_YARD_FEATURES_SUCCESS = "FETCH_YARD_FEATURES_SUCCESS";
